import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import convertRetainToPoint from '../../utils/convertRetainToPoint';
import { createMark } from '../../utils/convertAttributesToMarks';

function toggleMarksOnText(editor, marks) {
  var oldMarks = editor.value.marks;
  return Object.entries(marks).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        type = _ref2[0],
        data = _ref2[1];

    var newMark = createMark([type, data]);
    var oldMark = oldMarks.find(function (mark) {
      return newMark.type === mark.type;
    });
    var hasBeenRemoved = !data;

    if (hasBeenRemoved) {
      if (oldMark) {
        editor.removeMark(oldMark);
      }
    } else if (oldMark) {
      editor.replaceMark(oldMark, newMark);
    } else {
      editor.addMark(newMark);
    }
  });
}

function mergeSimilarConsecutiveInlines(editor) {
  var anchorBlock = editor.value.anchorBlock;
  var current = anchorBlock.getClosestInline(editor.value.selection.anchor.key);
  if (!current) return editor;
  var previous = anchorBlock.getPreviousSibling(current.key);
  var emptyTexts = [];

  while (previous && previous.text.length === 0) {
    emptyTexts.push(previous);
    previous = anchorBlock.getPreviousSibling(previous.key);
  }

  if (!previous) return editor;

  if (previous.getIn(['data', 'entityId']) === current.getIn(['data', 'entityId'])) {
    editor.withoutNormalizing(function () {
      emptyTexts.forEach(function (emptyText) {
        return editor.removeNodeByKey(emptyText.key);
      });
      editor.mergeNodeByKey(current.key);
    });
  }
}

function toggleEntityOnText(editor, entity) {
  if (entity) {
    var type = entity.type,
        data = entity.data;
    editor.unwrapInline(type).wrapInline({
      type: type,
      data: data
    });
  } else if (entity === null) {
    editor.unwrapInline();
  }

  return mergeSimilarConsecutiveInlines(editor);
}

export default function updateTextAttributes(editor, retain, _ref3) {
  var entity = _ref3.entity,
      marks = _objectWithoutProperties(_ref3, ["entity"]);

  var _convertRetainToPoint = convertRetainToPoint(editor, retain),
      path = _convertRetainToPoint.path,
      offset = _convertRetainToPoint.offset;

  editor.moveFocusTo(path, offset);
  toggleMarksOnText(editor, marks);
  toggleEntityOnText(editor, entity);
  return editor.moveTo(editor.value.selection.end.path, editor.value.selection.end.offset);
}